import { Feature, IFeatureContext, IFeature } from './Feature';
import * as d3 from 'd3';
import { PixoSpatial, PixoPt } from '../Pixospatial';
import { getGeom } from '@turf/invariant';
import { point, Geometry, GeometryObject } from '@turf/helpers';


export class PointFeature extends Feature {
	private pointGroup: any;

	public get type(): string {
		return 'point';
	}

	constructor(context: IFeatureContext, spatialContext: PixoSpatial = null) {
		super(context, spatialContext);
		this.pointGroup = context.pointGroup.append('g');
		this.points = [];
		this.groups = [this.pointGroup];
	}
	AddVertex(ptInfo, xProp = 'x', yProp = 'y') {
		if (this.points.length === 1) {
			return this.points[0];
		}
		const pt: any = this.MakeVertex(this.points, this.pointGroup, ptInfo, xProp, yProp);
		this.Select(pt.id);
    this.UpdateContextHandler();
    return pt;

	}
	Remove(): void {
		this.RemovePoints(this.points);
	}

	ToGeoJSONGeom():GeometryObject | false{
		if (this.points.length < 1) {
			return false;
		}
		return getGeom(point([this.points[0].coord.spatial.lng, this.points[0].coord.spatial.lat]));
	}
	FromGeoJSONGeom(geom: Geometry) {
		if(!geom) {
			return;
		}
		const coord = geom.coordinates;
		const ptInfo: PixoPt = this.spatialContext.SpatialCoord({ lng: coord[0], lat: coord[1] }).convert();
		this.AddVertex(ptInfo);
	}
  ToggleVis(isVis?:boolean) {
    let wasVis = !this.pointGroup.node().classList.contains('hidden');
    isVis = (isVis !== undefined) ? isVis : !wasVis;
    this.pointGroup.node().classList.toggle('hidden',isVis);
    // this.segmentGroup.node().classList.toggleClass('hidden',isVis);
  }
  GetVis():boolean {
    return !this.pointGroup.node().classList.contains('hidden');
  }
}
